/* FansBRANDS Help Center RO V12 - native Shopify CAPTCHA submit */
(function(){
  var root=document.getElementById('fbh');
  if(!root)return;

  var form=root.querySelector('#form');
  var btn=root.querySelector('#submit');
  if(!form||!btn)return;

  root.dataset.fbhCaptchaSafe='1';
  var busy=false;

  function q(s){return root.querySelector(s);}
  function qa(s,c){return Array.prototype.slice.call((c||root).querySelectorAll(s));}
  function wrap(f){return f.closest('.field')||f.closest('.privacy')||f.parentElement;}

  function valid(f){
    if(f.type==='checkbox')return f.checked;
    if(f.tagName==='SELECT')return !!f.value;
    var v=(f.value||'').trim();
    if(f.hasAttribute('required')&&!v)return false;
    if(f.type==='email'&&!f.checkValidity())return false;
    if(f.id==='message'&&v.length<10)return false;
    if(f.name==='contact[name]'&&v.length<2)return false;
    return f.checkValidity();
  }

  function errorText(f){
    if(f.type==='checkbox')return 'Te rugăm să accepți politica de confidențialitate.';
    if(f.tagName==='SELECT')return 'Te rugăm să selectezi o opțiune.';
    if(f.type==='email')return 'Introdu o adresă de e-mail validă.';
    if(f.id==='message')return 'Descrie problema în câteva cuvinte.';
    return 'Completează acest câmp obligatoriu.';
  }

  function clearError(f){
    var w=wrap(f);f.classList.remove('bad');f.removeAttribute('aria-invalid');
    if(w){w.classList.remove('is-invalid','shake');var m=w.querySelector('.field-error');if(m)m.remove();}
  }

  function markError(f){
    var w=wrap(f);f.classList.add('bad');f.setAttribute('aria-invalid','true');
    if(w){
      w.classList.add('is-invalid');
      var m=w.querySelector('.field-error');
      if(!m){m=document.createElement('div');m.className='field-error';w.appendChild(m);}
      m.textContent=errorText(f);
      w.classList.remove('shake');void w.offsetWidth;w.classList.add('shake');
    }
  }

  function validate(){
    var fields=qa('[required]',form),first=null;
    fields.forEach(function(f){if(valid(f))clearError(f);else{markError(f);if(!first)first=f;}});
    if(first){
      (wrap(first)||first).scrollIntoView({behavior:'smooth',block:'center'});
      setTimeout(function(){try{first.focus({preventScroll:true});}catch(e){first.focus();}},250);
      return false;
    }
    return true;
  }

  function nextTicket(){
    var d=new Date(),yy=String(d.getFullYear()).slice(-2),key='fb_ticket_seq_'+yy,n=0;
    try{n=parseInt(localStorage.getItem(key)||'0',10)||0;}catch(e){}
    n++;
    try{localStorage.setItem(key,String(n));}catch(e){}
    return 'RO - '+yy+String(n).padStart(4,'0');
  }

  function productLines(){
    return qa('[data-z]',q('#rows')).map(function(x,i){
      function val(s){var e=x.querySelector(s);return e?(e.value||'').trim():'';}
      return (i+1)+'. '+(val('[data-a]')||'-')+
        ' | cod produs: '+(val('[data-b]')||'-')+
        ' | mărime returnată: '+(val('[data-d]')||'-')+
        ' | buc.: '+(val('[data-q]')||'1')+
        ' | acțiune: '+(val('[data-u]')||'-');
    });
  }

  function preparePayload(){
    var issue=q('#issue'),resolution=q('#resolution'),message=q('#message'),order=q('#order');
    var id=nextTicket();
    var subject=(issue&&issue.value)||'Altele';
    var fullSubject=id+' | '+subject;
    var ticket=q('#ticketno'),summary=q('#casesummary'),emailSubject=q('#emailsubject'),body=q('#body');
    if(ticket)ticket.value=id;
    if(summary)summary.value=fullSubject;
    if(emailSubject)emailSubject.value=fullSubject;

    var lines=[
      'SUBIECT: '+fullSubject,
      'NUMĂR DE REFERINȚĂ: '+id,
      'TIPUL PROBLEMEI: '+subject,
      'Soluția solicitată: '+((resolution&&resolution.value)||'-'),
      'Numărul comenzii: '+((order&&order.value)||'-'),
      'Descriere: '+((message&&message.value.trim())||'-'),
      'Produse:'
    ].concat(productLines());

    var media=q('#media');
    if(media&&media.value.trim())lines.push('Link pentru partajarea fișierelor: '+media.value.trim());
    var pendingFiles=Number(root.dataset.fbhAttachmentCount||0);
    if(pendingFiles>0)lines.push('Număr de fișiere selectate: '+pendingFiles+'. Fișierele nu sunt atașate automat e-mailului.');
    if(body)body.value=lines.join('\n');
    return id;
  }

  function rememberTicket(id){
    try{sessionStorage.setItem('fb_ticket',id);}catch(e){}
  }

  /*
   * CAPTCHA-safe submit:
   * Do not prevent a valid native Shopify contact submission and do not call
   * form.submit() ourselves. Shopify's own handler must receive the original
   * submit event so it can create and attach h-captcha-response.
   */
  form.addEventListener('submit',function(e){
    if(busy){
      e.preventDefault();
      return;
    }
    if(!validate()){
      e.preventDefault();
      return;
    }

    var hp=form.querySelector('input[name="website"]');
    if(hp&&hp.value){
      e.preventDefault();
      return;
    }

    var id=preparePayload();
    rememberTicket(id);

    /* Important: intentionally no preventDefault() here. */
    busy=true;
    btn.textContent='SE TRIMITE...';
  });

  form.addEventListener('input',function(e){
    if(e.target.hasAttribute&&e.target.hasAttribute('required')&&valid(e.target))clearError(e.target);
  });
  form.addEventListener('change',function(e){
    if(e.target.hasAttribute&&e.target.hasAttribute('required')&&valid(e.target))clearError(e.target);
  });

  /* After Shopify redirects back following a successful native submit, show popup once. */
  var posted=q('#postedOk');
  if(posted){
    var t='';
    try{t=sessionStorage.getItem('fb_ticket')||'';sessionStorage.removeItem('fb_ticket');}catch(e){}
    var popup=q('#popup'),ticketshow=q('#ticketshow');
    if(ticketshow)ticketshow.textContent=t||'Trimis';
    if(popup){popup.classList.add('open');popup.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';}
    try{
      var u=new URL(location.href);
      u.searchParams.delete('contact_posted');
      history.replaceState(null,'',u.pathname+(u.search?'?'+u.searchParams.toString():'')+u.hash);
    }catch(e){}
  }

  var serverBox=q('#err');
  if(serverBox&&serverBox.textContent.trim()){
    setTimeout(function(){serverBox.scrollIntoView({behavior:'smooth',block:'center'});},80);
  }
})();

(function(){var R=document.getElementById('fbh');if(!R)return;try{var cu=new URL(location.href);if(cu.searchParams.has('contact_posted')){cu.searchParams.delete('contact_posted');history.replaceState(null,'',cu.pathname+(cu.search?'?'+cu.searchParams.toString():'')+(location.hash==='#form'?'':location.hash));var se=R.querySelector('#err');if(se){se.innerHTML='';se.style.display='none';}}}catch(_oldPost){}var HC=R.dataset.helpCenterUrl||location.pathname;try{var P=new URLSearchParams(window.location.search),L=P.get('hcUrl');if(L){var D=L;try{D=decodeURIComponent(L)}catch(_e){}var M=D.match(/(\d{6,})/),U=M&&window.__FBH_LEGACY_MAP?window.__FBH_LEGACY_MAP[M[1]]:null;if(U){window.location.replace(U);return;}if(window.history&&history.replaceState)history.replaceState({},'',HC+'#knowledge');var LN=document.getElementById('legacyNote');if(LN)LN.hidden=false;setTimeout(function(){var K=document.getElementById('knowledge');if(K)K.scrollIntoView({behavior:'smooth',block:'start'});},80);}}catch(_legacyErr){}var $=function(s,c){return(c||R).querySelector(s)},$$=function(s,c){return[].slice.call((c||R).querySelectorAll(s))},N=function(v){return(v||'').toLocaleLowerCase('ro-RO').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim()},E=function(v){var d=document.createElement('div');d.textContent=v||'';return d.innerHTML};function sortChildren(parentSelector,itemSelector){$$(parentSelector).forEach(function(parent){var items=[].slice.call(parent.querySelectorAll(':scope > '+itemSelector));items.sort(function(a,b){return(Number(a.dataset.sort)||9999)-(Number(b.dataset.sort)||9999);});items.forEach(function(item){parent.appendChild(item);});});}sortChildren('#kbTopics','.topic');sortChildren('.article-list','.article-row');var hp=new URLSearchParams(location.search),hr=hp.get('hc_return');if(hr){var hx=$$('.article-row').find(function(x){return x.dataset.h===hr;});if(hx){var hd=hx.closest('details.topic');if(hd){hd.open=true;hd.setAttribute('open','');}setTimeout(function(){var y=hx.getBoundingClientRect().top+window.pageYOffset-(window.innerHeight*.28);window.scrollTo({top:Math.max(0,y),behavior:'auto'});hx.classList.add('return-focus');setTimeout(function(){hx.classList.remove('return-focus');},1800);try{history.replaceState(null,'',location.pathname);}catch(_clean){}},90);}}var q=$('#q'),qr=$('#qr'),qc=$('#qc'),idx=$$('.s').map(function(el){var t=el.dataset.t||'',g=el.dataset.g||'',p=el.closest('.topic');return{el:el,t:t,p:p?(p.dataset.p||'Centru de ajutor'):'FansBRANDS®',s:N(t+' '+g+' '+el.textContent)};});function score(x,z){var t=N(x.t),n=0;if(t===z)n+=100;if(t.indexOf(z)===0)n+=60;if(t.indexOf(z)>-1)n+=30;if(x.s.indexOf(z)>-1)n+=10;return n;}function rememberArticle(el){try{if(!el||!el.dataset.h)return;sessionStorage.setItem('fbh_last_article',el.dataset.h);var d=el.closest('details.topic');if(d)sessionStorage.setItem('fbh_last_category',d.id||'');}catch(_e){}}function openItem(x){var u=x.el.getAttribute('href')||x.el.dataset.href;if(u){rememberArticle(x.el);window.location.href=u;return;}x.el.scrollIntoView({behavior:'smooth',block:'center'});}function render(){var z=N(q.value);if(!z){qr.hidden=true;qr.innerHTML='';return;}var a=idx.map(function(x){return{x:x,n:score(x,z)};}).filter(function(v){return v.n>0}).sort(function(a,b){return b.n-a.n});qr.hidden=false;qr.innerHTML='';if(!a.length){qr.innerHTML='<div class="nores">Niciun rezultat.</div>';return;}var h=document.createElement('div');h.className='rh';h.innerHTML='<span>Rezultate</span><strong>'+a.length+' rezultate</strong>';qr.appendChild(h);a.slice(0,8).forEach(function(v){var b=document.createElement('button');b.type='button';b.className='res';b.innerHTML='<span class="ri"><svg viewBox="0 0 24 24"><circle stroke="#e10600" cx="11" cy="11" r="7"/><path stroke="#e10600" d="m16 16 5 5"/></svg></span><span class="rc"><strong>'+E(v.x.t)+'</strong><small>'+E(v.x.p)+'</small></span><span style="font-size:22px;line-height:1">›</span>';b.onclick=function(){openItem(v.x)};qr.appendChild(b);});}$$('.article-row').forEach(function(a){a.addEventListener('click',function(){rememberArticle(a);});});q.addEventListener('input',render);q.addEventListener('focus',function(){if(q.value.trim())render();});qc.onclick=function(){q.value='';qr.hidden=true;q.focus();};document.addEventListener('click',function(e){if(!e.target.closest('#search'))qr.hidden=true;});var issue=$('#issue'),resolution=$('#resolution');function topOffset(){var sels=['#shopify-section-header','sticky-header','.shopify-section-header-sticky','.header-wrapper','header.header'];var max=0;sels.forEach(function(s){document.querySelectorAll(s).forEach(function(el){var cs=getComputedStyle(el),r=el.getBoundingClientRect();if((cs.position==='fixed'||cs.position==='sticky')&&r.height>0&&r.top<=8&&r.bottom>max)max=r.bottom;});});var fallback=window.innerWidth<768?104:88;return Math.max(max,fallback)+14;}function goTicket(){var t=$('#ticket');if(!t)return;var y=t.getBoundingClientRect().top+window.pageYOffset-topOffset();window.scrollTo({top:Math.max(0,y),behavior:'smooth'});}$$('a[href="#ticket"]').forEach(function(a){a.addEventListener('click',function(e){e.preventDefault();try{history.pushState(null,'',location.pathname+location.search+'#ticket');}catch(_h){}setTimeout(goTicket,20);});});if(location.hash==='#ticket'){setTimeout(goTicket,120);}$$('.tl').forEach(function(a){a.addEventListener('click',function(){if(a.dataset.i)issue.value=a.dataset.i;if(a.dataset.r)resolution.value=a.dataset.r;});});$$('[data-c]').forEach(function(b){b.onclick=function(){var v=b.dataset.c,o=b.textContent;function done(){b.textContent='COPIAT ✓';setTimeout(function(){b.textContent=o;},1200);}if(navigator.clipboard&&window.isSecureContext){navigator.clipboard.writeText(v).then(done);}else{var t=document.createElement('textarea');t.value=v;document.body.appendChild(t);t.select();document.execCommand('copy');t.remove();done();}};});var rows=$('#rows'),add=$('#add'),limit=$('#limit');function row(){return'<div class="pr" data-z><div class="pn" data-n></div><div class="pfs"><div class="pf"><label>Denumirea produsului</label><input data-a placeholder="Ex.: tricou Ferrari"></div><div class="pf"><label>Cod produs (SKU)</label><input data-b placeholder="Dacă este cunoscut"></div><div class="pf"><label>Mărimea returnată</label><input data-d placeholder="Ex.: M"></div><div class="pf"><label>Cantitate</label><input data-q type="number" min="1" value="1"></div><div class="pf"><label>Acțiune solicitată</label><select data-u><option value="">Selectează</option><option>Retur</option><option>Reclamație</option><option>Informații</option></select></div></div><button class="rm" type="button" data-m>×</button></div>';}function upd(){var r=$$('[data-z]',rows);r.forEach(function(x,i){$('[data-n]',x).textContent=i+1;$('[data-m]',x).disabled=r.length===1;});add.disabled=r.length>=10;limit.style.display=r.length>=10?'block':'none';}add.onclick=function(){if($$('[data-z]',rows).length>=10)return;var d=document.createElement('div');d.innerHTML=row();rows.appendChild(d.firstElementChild);upd();};rows.addEventListener('click',function(e){var b=e.target.closest('[data-m]');if(!b)return;if($$('[data-z]',rows).length>1){b.closest('[data-z]').remove();upd();}});upd();var images=$('#images'),video=$('#video'),ilist=$('#ilist'),vlist=$('#vlist'),istatus=$('#istatus'),vstatus=$('#vstatus'),err=$('#err'),MAX=8,MAXB=4608*1024,currentImages=[],currentVideo=null;function size(n){if(n<1024)return n+' B';if(n<1048576)return Math.round(n/1024)+' KB';return(n/1048576).toFixed(1)+' MB';}function imgBytes(){return currentImages.reduce(function(n,f){return n+f.size;},0);}function totalBytes(){return imgBytes()+(currentVideo?currentVideo.size:0);}function st(el,cls,txt){el.className='status '+cls;el.textContent=txt;}function stats(el,type,count,max,msg,bad){R.dataset.fbhAttachmentCount=String(currentImages.length+(currentVideo?1:0));var t=count+' / '+max+' '+type+' • total '+Math.round(totalBytes()/1024)+' / 4608 KB';if(msg)t+=' • '+msg;st(el,bad?'badst':count?'goodst':'',(bad?'! ':count?'✓ ':'')+t);}function same(a,b){return a.name===b.name&&a.size===b.size&&a.lastModified===b.lastModified;}function renderImages(){ilist.innerHTML='';if(!currentImages.length)return;var w=document.createElement('div');w.className='thumbs';currentImages.forEach(function(f,i){var it=document.createElement('div');it.className='thumb';it.innerHTML='<button type="button" class="delpic" data-di="'+i+'" aria-label="Șterge imaginea">×</button><img alt=""><div><strong></strong><span></span></div>';it.querySelector('strong').textContent=f.name;it.querySelector('span').textContent=size(f.size);var im=it.querySelector('img'),u=URL.createObjectURL(f);im.src=u;im.onload=function(){URL.revokeObjectURL(u);};im.onerror=function(){URL.revokeObjectURL(u);im.alt='Previzualizare indisponibilă';};w.appendChild(it);});ilist.appendChild(w);}function renderVideo(){vlist.innerHTML='';if(!currentVideo)return;var d=document.createElement('div');d.className='file';d.innerHTML='<strong></strong><span></span><button type="button" class="delfile" aria-label="Șterge videoclipul">×</button>';d.querySelector('strong').textContent=currentVideo.name;d.querySelector('span').textContent=size(currentVideo.size);vlist.appendChild(d);}function refresh(){stats(istatus,'imagini',currentImages.length,8);stats(vstatus,'videoclipuri',currentVideo?1:0,1);}var uploadNote=document.createElement('p');uploadNote.className='required-note';uploadNote.setAttribute('data-fbh-upload-notice','');uploadNote.textContent='Previzualizare: fișierele selectate nu sunt atașate automat. Linkul de partajare de mai jos este opțional.';images.closest('.field').appendChild(uploadNote);
images.onchange=function(){var fs=[].slice.call(images.files||[]),added=0,errs=[];fs.forEach(function(f){if(!(/^image\/(jpeg|png|webp|heic|heif)$/i.test(f.type)||/\.(jpe?g|png|webp|heic|heif)$/i.test(f.name))){errs.push('format incorect: '+f.name);return;}if(currentImages.some(function(x){return same(x,f)})){errs.push('deja adăugat: '+f.name);return;}if(currentImages.length>=MAX){errs.push('maximum 8 imagini');return;}if(totalBytes()+f.size>MAXB){errs.push('limita de dimensiune depășită: '+f.name);return;}currentImages.push(f);added++;});images.value='';renderImages();if(errs.length){stats(istatus,'imagini',currentImages.length,8,errs[0]+(errs.length>1?' +'+(errs.length-1)+' alte erori':''),true);}else{stats(istatus,'imagini',currentImages.length,8,added?added+' imagini adăugate':'');}stats(vstatus,'videoclipuri',currentVideo?1:0,1);};ilist.onclick=function(e){var b=e.target.closest('[data-di]');if(!b)return;currentImages.splice(Number(b.dataset.di),1);renderImages();stats(istatus,'imagini',currentImages.length,8,'imagine ștearsă');stats(vstatus,'videoclipuri',currentVideo?1:0,1);};video.onchange=function(){var f=video.files&&video.files[0]?video.files[0]:null;video.value='';if(!f)return;var ok=/^video\/(mp4|quicktime)$/i.test(f.type)||/\.(mp4|mov)$/i.test(f.name);if(!ok){stats(vstatus,'videoclipuri',currentVideo?1:0,1,'format video neacceptat',true);return;}if(imgBytes()+f.size>MAXB){stats(vstatus,'videoclipuri',currentVideo?1:0,1,'limita de dimensiune depășită',true);return;}currentVideo=f;renderVideo();stats(vstatus,'videoclipuri',1,1,'adăugat cu succes');stats(istatus,'imagini',currentImages.length,8);};vlist.onclick=function(e){if(!e.target.closest('.delfile'))return;currentVideo=null;renderVideo();stats(vstatus,'videoclipuri',0,1,'videoclip șters');stats(istatus,'imagini',currentImages.length,8);};function products(){return $$('[data-z]',rows).map(function(x){return{termek:$('[data-a]',x).value.trim(),cikkszam:$('[data-b]',x).value.trim(),visszakuldott_meret:$('[data-d]',x).value.trim(),mennyiseg:$('[data-q]',x).value||'1',teendo:$('[data-u]',x).value};}).filter(function(x){return x.termek||x.cikkszam||x.visszakuldott_meret||x.teendo;});}var form=$('#form'),popup=$('#popup'),body=$('#body'),ticketno=$('#ticketno'),casesummary=$('#casesummary'),emailsubject=$('#emailsubject'),ticketshow=$('#ticketshow');form.addEventListener('reset',function(){currentImages=[];currentVideo=null;renderImages();renderVideo();refresh();});
function newTicket(){
var d=new Date(),yy=String(d.getFullYear()).slice(-2),key='fb_ticket_seq_'+yy,n=0;
try{n=parseInt(localStorage.getItem(key)||'0',10)||0;}catch(e){}
n+=1;
try{localStorage.setItem(key,String(n));}catch(e){}
return'RO - '+yy+String(n).padStart(4,'0');
}function fieldWrap(f){return f.closest('.field')||f.closest('.privacy')||f.parentElement;}
function fieldValid(f){
if(f.type==='checkbox')return f.checked;
if(f.tagName==='SELECT')return!!f.value;
if((f.tagName==='INPUT'||f.tagName==='TEXTAREA')&&f.hasAttribute('required')){
var v=(f.value||'').trim();
if(!v)return false;
if(f.id==='message'&&v.length<10)return false;
if(f.name==='contact[name]'&&v.length<2)return false;
}
return f.checkValidity();
}
function errText(f){
if(f.type==='checkbox')return'Te rugăm să accepți politica de confidențialitate.';
if(f.tagName==='SELECT')return'Te rugăm să selectezi o opțiune.';
if(f.type==='email'&&f.value)return'Introdu o adresă de e-mail validă.';
if(f.id==='message'&&((f.value||'').trim().length<10))return'Descrie problema în câteva cuvinte.';
return'Completează acest câmp obligatoriu.';
}
function clearInvalid(f){
var w=fieldWrap(f);f.classList.remove('bad');f.removeAttribute('aria-invalid');
if(w){w.classList.remove('is-invalid','shake');var m=w.querySelector('.field-error');if(m)m.remove();}
}
function markInvalid(f){
var w=fieldWrap(f);f.classList.add('bad');f.setAttribute('aria-invalid','true');
if(w){
w.classList.add('is-invalid');
var m=w.querySelector('.field-error');
if(!m){m=document.createElement('div');m.className='field-error';w.appendChild(m);}
m.textContent=errText(f);
w.classList.remove('shake');void w.offsetWidth;w.classList.add('shake');
}
}
function validate(){
var a=$$('[required]',form),first=null;
a.forEach(function(f){if(!fieldValid(f)){markInvalid(f);if(!first)first=f;}else clearInvalid(f);});
if(first){
var w=fieldWrap(first)||first;
w.scrollIntoView({behavior:'smooth',block:'center'});
setTimeout(function(){try{first.focus({preventScroll:true});}catch(_f){first.focus();}},280);
return false;
}
return true;
}
form.addEventListener('input',function(e){if(e.target.hasAttribute('required')&&fieldValid(e.target))clearInvalid(e.target);});
form.addEventListener('change',function(e){if(e.target.hasAttribute('required')&&fieldValid(e.target))clearInvalid(e.target);});
function close(){popup.classList.remove('open');popup.setAttribute('aria-hidden','true');document.body.style.overflow='';}$$('[data-x]').forEach(function(x){x.onclick=close;});})();

(function(){
  var root=document.getElementById('fbh');
  if(!root || root.dataset.fbhPanelLayout==='1')return;
  root.dataset.fbhPanelLayout='1';

  var quick=root.querySelector('.quick-grid');
  var topics=root.querySelector('.topics');
  var quickPanel=null;
  var topicPanel=null;
  var quickActive=null;
  var topicActive=null;

  function directBody(detail){
    if(!detail)return null;
    for(var i=0;i<detail.children.length;i++){
      if(detail.children[i].classList && detail.children[i].classList.contains('body'))return detail.children[i];
    }
    return null;
  }

  function restore(detail,panel){
    if(!detail || !panel)return;
    var body=panel.querySelector(':scope > .body');
    if(body)detail.appendChild(body);
  }

  function ensureQuickPanel(){
    if(!quick)return null;
    if(!quickPanel){
      quickPanel=document.createElement('div');
      quickPanel.className='fbh-quick-expanded-panel';
      quick.appendChild(quickPanel);
    }
    return quickPanel;
  }

  function ensureTopicPanel(){
    if(!topics)return null;
    if(!topicPanel){
      topicPanel=document.createElement('div');
      topicPanel.className='fbh-topic-expanded-panel';
    }
    return topicPanel;
  }

  function placeTopicPanel(detail){
    var items=[].slice.call(topics.querySelectorAll(':scope > details.topic'));
    var idx=items.indexOf(detail);
    if(idx<0)return;

    topicPanel.classList.remove('is-from-left','is-from-right');
    topicPanel.classList.add(idx%2===0?'is-from-left':'is-from-right');

    var rowEnd=Math.min(items.length-1,idx%2===0?idx+1:idx);
    var anchor=items[rowEnd];
    anchor.insertAdjacentElement('afterend',topicPanel);
  }

  function syncQuick(){
    if(!quick)return;
    var desktop=window.matchMedia('(min-width:1100px)').matches;
    var open=quick.querySelector(':scope > details.card[open]');

    if(!desktop){
      if(quickActive && quickPanel)restore(quickActive,quickPanel);
      if(quickPanel)quickPanel.remove();
      quickPanel=null;quickActive=null;
      return;
    }

    var panel=ensureQuickPanel();
    if(quickActive && quickActive!==open)restore(quickActive,panel);
    quickActive=open||null;
    if(!open){
      if(panel)panel.innerHTML='';
      return;
    }
    var body=directBody(open);
    if(body)panel.appendChild(body);
    quick.appendChild(panel);
  }

  function syncTopics(){
    if(!topics)return;
    var desktop=window.matchMedia('(min-width:768px)').matches;
    var open=topics.querySelector(':scope > details.topic[open]');

    if(!desktop){
      if(topicActive && topicPanel)restore(topicActive,topicPanel);
      if(topicPanel)topicPanel.remove();
      topicPanel=null;topicActive=null;
      return;
    }

    var panel=ensureTopicPanel();
    if(topicActive && topicActive!==open)restore(topicActive,panel);
    topicActive=open||null;
    if(!open){
      if(panel.parentNode)panel.remove();
      return;
    }
    var body=directBody(open);
    if(body)panel.appendChild(body);
    placeTopicPanel(open);
  }

  function selectOpened(group,selector,detail){
    if(!detail.open)return;
    group.querySelectorAll(':scope > '+selector).forEach(function(other){if(other!==detail)other.open=false;});
  }

  function prepareSummaryClick(group,selector){
    group.addEventListener('click',function(e){
      var summary=e.target.closest('summary');
      if(!summary)return;
      var detail=summary.parentElement;
      if(detail.parentElement!==group||!detail.matches(selector)||detail.open)return;
      group.querySelectorAll(':scope > '+selector).forEach(function(other){if(other!==detail)other.open=false;});
    });
  }

  if(quick){
    prepareSummaryClick(quick,'details.card');
    quick.addEventListener('toggle',function(e){
      if(e.target && e.target.matches('details.card')){selectOpened(quick,'details.card',e.target);syncQuick();}
    },true);
  }

  if(topics){
    prepareSummaryClick(topics,'details.topic');
    topics.addEventListener('toggle',function(e){
      if(e.target && e.target.matches('details.topic')){selectOpened(topics,'details.topic',e.target);syncTopics();}
    },true);
  }

  var resizeTimer;
  window.addEventListener('resize',function(){
    clearTimeout(resizeTimer);
    resizeTimer=setTimeout(function(){syncQuick();syncTopics();},120);
  });

  syncQuick();
  syncTopics();
})();
